// Small helpers for consistent data shaping across pages.
//
// pickDetail(siteDetails) — site_details has a unique site_id FK, so
// PostgREST detects it as a 1:1 relationship and returns it as an
// embedded object, not an array. Older code wrote `site.site_details?.[0]`
// which works against arrays but reads as undefined against an object.
// This helper normalizes both shapes so callers can write
// `pickDetail(site.site_details)` and trust the result.
//
// Returns null when there's no detail row or the input is empty.
export function pickDetail(siteDetails) {
  if (!siteDetails) return null
  if (Array.isArray(siteDetails)) return siteDetails[0] || null
  // Defensive: treat empty objects as missing too, in case a future
  // schema tweak ever returns {} instead of null.
  if (typeof siteDetails === 'object' && Object.keys(siteDetails).length === 0) return null
  return siteDetails
}
